import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class OrganisationsService {

    constructor(private http: HttpClient) { }

    list(filter: any): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}organisations`, filter);
    }

    getById(id: string): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}organisations/view/${encodeURIComponent(id)}`);
    }

    create(payload: any): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}organisations/create`, payload);
    }

    update(id: string, payload: any): Observable<any> {
        return this.http.put<any>(
            `${environment.apiUrl}organisations/update/${encodeURIComponent(id)}`,
            payload
        );
    }

    delete(id: string): Observable<any> {
        return this.http.delete<any>(
            `${environment.apiUrl}organisations/delete/${encodeURIComponent(id)}`
        );
    }

    getMembershipMeta(organisationId: string): Observable<any> {
        return this.http.get<any>(
            `${environment.apiUrl}organisations/${encodeURIComponent(organisationId)}/membership-ids/meta`
        );
    }

    uploadMembershipIds(organisationId: string, payload: {
        membership_ids: Array<string | { member_id: string; mmcepi_id?: string }>;
        membership_id_filename?: string | null;
    }): Observable<any> {
        return this.http.post<any>(
            `${environment.apiUrl}organisations/${encodeURIComponent(organisationId)}/membership-ids`,
            payload
        );
    }

    downloadMembershipIds(organisationId: string): Observable<Blob> {
        return this.http.get(
            `${environment.apiUrl}organisations/${encodeURIComponent(organisationId)}/membership-ids/download`,
            { responseType: 'blob' }
        );
    }
}
